import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import formatCnpj from '@brazilian-utils/format-cnpj';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { Dropdown } from 'react-bootstrap';

import EconomicGroup from '~/components/pages/Portal/EconomicGroup';
import BadgeNotification from '~/components/layout/BadgeNotification';
import BadgeNotificationMobile from '~/components/layout/BadgeNotificationMobile';

import iconRevenda from '~/assets/images/Header/ic_revenda.svg';
import iconUltragaz from '~/assets/images/Header/ultragaz-horizontal.svg';
import iconRevendaCinza from '~/assets/images/Header/ic_revenda-cinza.svg';
import iconExit from '~/assets/images/Header/exit.svg';
import iconEmployee from '~/assets/images/Header/worker.svg';
import '~/components/styles/Global.css';

import {
  Container,
  ResaleContainer,
  ResaleContent,
  ReleaseIcon,
  ReleaseInfo,
  UserInfoContainer,
  UserTexts,
  AvatarIcon,
  DesktopWrapper,
  MobileWrapper,
  LogoContainer,
  MobileUserInfoContainer,
  ResaleMobileContainer,
  ResaleMobileContent,
  ColorIconMobile,
  ColorIconDesktop,
  CreatedIconStyles,
  CreatedIconStylesMobile,
  ConfigModal,
  AreaTop,
  TextNotification,
  AreaItemNotification,
  AreaItemNotificationTitle,
  AreaItemNotificationScroll,
  AreaItemNotificationDate,
  AreaItemNotificationData,
  AreaNotificationExit
} from './styles';
import { toast } from 'react-toastify';
import api from '~/services/api';

function Header({ stores, disabledOnMobile, modeSimple }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const expand = useSelector(state => state.economicGroupReducer.expand);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const userReducer = useSelector(state => state.userReducer);
  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [storeName, setStoreName] = useState('');
  const [storeDocument, setStoreDocument] = useState('');
  const storeDocumentLocal = localStorage.getItem('storeDocument');
  useEffect(() => {
    dispatch({ type: 'SET_EXPAND', expand: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setUserName(localStorage.getItem('userName'));
    setUserEmail(localStorage.getItem('userEmail'));
    setStoreName(localStorage.getItem('storeName'));
    setStoreDocument(localStorage.getItem('storeDocument'));
  }, [userReducer.response, storeDocumentLocal]);

  useEffect(() => {
    setUserName(localStorage.getItem('userName'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('userName')])

  const verifyDateValid = (value) => {
    var todaysDate = new Date();

    if (!value.start_date && !value.end_date) return true;
    if (!value.start_date && value.end_date) {
      if (new Date(value.end_date) >= todaysDate) return true;
      return false;
    }
    if (value.start_date && !value.end_date) {
      if (new Date(value.start_date) <= todaysDate) return true;
      return false;
    }
    if (new Date(value.start_date) <= todaysDate && new Date(value.end_date) >= todaysDate) {
      return true;
    }
    return false;
  }

  function hasRead() {
    if (notificationReducer.notifications.length > 0) {
      const hasNotRead = notificationReducer.notifications.filter((item) => item.number_of_read === null || parseInt(item.number_of_read) === 0);
      const itemsDateValid = hasNotRead.filter((item) => verifyDateValid(item));
      return itemsDateValid.length;
    }
    return 0;
  }

  async function signOut() {
    const token = localStorage.getItem('access_token');
    const body = new URLSearchParams();
    body.append('token', token);
    body.append('token_type_hint', 'access_token');

    try {
      const res = await api.post('oauth/revoke', body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
        },
      });

      if (res.status === 200) {
        const mfaHashHeader = localStorage.getItem('X-MFA-Hash');
        localStorage.clear();
        if (mfaHashHeader !== null) {
            localStorage.setItem('X-MFA-Hash', mfaHashHeader);
        }
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      } else {
        toast.error('Falha ao sair. Por favor, tente novamente.');
      }
    } catch (error) {
      toast.error('Erro ao tentar sair. Por favor, tente novamente.');
      console.error('Erro ao revogar o token:', error);
    }
  }

  return (
    <Container disabledOnMobile={disabledOnMobile}>
      <DesktopWrapper>
        <ResaleContainer>
          <AreaTop>
            <EconomicGroup stores={stores} mobile={false}>
              <ResaleContent expand={economicGroupReducer.expand}>
                <ReleaseIcon src={iconRevenda} alt="icone revenda" />
                <ReleaseInfo color="#000FFF">
                  {storeName} - CNPJ: {formatCnpj(storeDocument)}
                </ReleaseInfo>
                {expand ? (
                  <ExpandLessIcon style={ColorIconDesktop} />
                ) : (
                  <ExpandMoreIcon style={ColorIconDesktop} />
                )}
              </ResaleContent>
            </EconomicGroup>
          </AreaTop>
          <AreaNotificationExit>
            <ConfigModal id="dropdown-custom-components" onClick={() => history.push('/segmented-comunication') }>
              <BadgeNotification readValue={hasRead()} />
            </ConfigModal>
            <Dropdown
              style={{
                textAlign: 'right',
                marginTop: 10,
              }}
              drop="down"
            >
              <ConfigModal id="dropdown-custom-components">
                <i class="fa fa-cog" aria-hidden="true" />
              </ConfigModal>
              <Dropdown.Menu id="dropdown-logout">
                <b>Opções</b>
                {!localStorage.getItem('ownerid') && (
                  <Dropdown.Item
                    style={{
                      marginLeft: -25,
                      marginTop: 10,
                      width: '100%',
                      color: '#808080',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      history.push('/usuarios');
                    }}
                  >
                    <img
                      src={iconEmployee}
                      className="mr-2"
                      fill="#000FFF"
                      style={{ transform: 'scaleX(-1)' }}
                      alt='Icone funcionario'
                    />
                    Lista de usuários
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  style={{
                    marginLeft: -25,
                    marginTop: 10,
                    width: '100%',
                    color: '#808080',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    dispatch({ type: "SET_STEP", step: 0 });
                    dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
                    dispatch({
                      type: "SET_PENDENCIES",
                      pendencies: {
                        hasPendencies: false,
                        storesSelected: [],
                        rules: {
                          s5: true
                        }
                      }
                    });
                    dispatch({
                      type: "RESET_NOTIFICATION"
                    });
                    signOut();
                    ;
                  }}
                >
                  <img
                    src={iconExit}
                    className="mr-2"
                    fill="#000FFF"
                    style={{ transform: 'scaleX(-1)' }}
                    alt='icone sair'
                  />
                  Sair do MAP
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </AreaNotificationExit>
        </ResaleContainer>
        {!modeSimple && userName ? (
          <UserInfoContainer>
            <AvatarIcon className="fa fa-user-circle" alt="Avatar icon" />
            <UserTexts color="#000FFF">
              <h6>
                Olá, {userName !== 'undefined' && userName}
                <button onClick={() => history.push('/editar-perfil')}>
                  <CreateOutlinedIcon style={CreatedIconStyles} />
                </button>
              </h6>
              <span>{userEmail}</span>
            </UserTexts>
          </UserInfoContainer>
        ) : null}
      </DesktopWrapper>
      <MobileWrapper lapidar={window.location.pathname.slice(0, 8) === "/lapidar"}>
        {
          window.location.pathname.slice(0, 8) === "/lapidar" ? (
            <ResaleContainer lapidar={true}>
              <EconomicGroup lapidar={true} stores={stores} mobile={false}>
                <ResaleContent expand={economicGroupReducer.expand}>
                  <ReleaseIcon src={iconRevenda} alt="icone revenda" />
                  <ReleaseInfo color="#FFF">
                    {storeName} - CNPJ: {formatCnpj(storeDocument)}
                  </ReleaseInfo>
                  {expand ? (
                    <ExpandLessIcon style={ColorIconDesktop} />
                  ) : (
                    <ExpandMoreIcon style={ColorIconDesktop} />
                  )}
                </ResaleContent>
              </EconomicGroup>
            </ResaleContainer>
          ) : (
            <>
              <LogoContainer>
                <img src={iconUltragaz} alt="Icone ultragaz" />
                <AreaNotificationExit>
                  <ConfigModal id="dropdown-custom-components" onClick={() => history.push('/segmented-comunication') }>
                    <BadgeNotificationMobile readValue={hasRead()} />
                  </ConfigModal>
                  <Dropdown drop="down" className="dropdown-mobile">
                    <ConfigModal id="dropdown-custom-components">
                      <i className="fa fa-cog" style={{color:"#000FFF"}}/>
                    </ConfigModal>
                    <Dropdown.Menu id="dropdown-logout">
                      <b>Opções</b>
                      <Dropdown.Item
                        style={{
                          marginLeft: -25,
                          marginTop: 10,
                          width: '100%',
                          color: '#808080',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={() => {
                          history.push('/usuarios');
                        }}
                      >
                        <img
                          src={iconEmployee}
                          className="mr-2"
                          fill="#000FFF"
                          style={{
                            transform: 'scaleX(-1)',
                            width: 25,
                            marginBottom: 0,
                          }}
                          alt='icone funcionario'
                        />
                        Lista de usuários
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{
                          marginLeft: -25,
                          marginTop: 10,
                          width: '100%',
                          color: '#808080',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={() => {
                          dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
                          dispatch({
                            type: "SET_PENDENCIES",
                            pendencies: {
                              hasPendencies: false,
                              storesSelected: [],
                              rules: {
                                s5: true
                              }
                            }
                          });
                          dispatch({
                            type: "RESET_NOTIFICATION"
                          });
                          const mfaHashHeader = localStorage.getItem('X-MFA-Hash');
                          localStorage.clear();
                          if (mfaHashHeader !== null) {
                              localStorage.setItem('X-MFA-Hash', mfaHashHeader);
                          }
                          dispatch({ type: "SET_STEP", step: 0 });
                          setTimeout(() => {
                            window.location.href = '/';
                          }, 1000);
                        }}
                      >
                        <img
                          src={iconExit}
                          className="mr-2"
                          fill="#000FFF"
                          style={{
                            transform: 'scaleX(-1)',
                            width: 25,
                            marginBottom: 0,
                          }}
                          alt='icone sair'
                        />
                        Sair do MAP
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </AreaNotificationExit>
              </LogoContainer>
              <MobileUserInfoContainer>
                <i className="fa fa-user-circle mr-3" />
                <UserTexts color="#000FFF">
                  <h6>
                    Olá, {userName !== 'undefined' && userName}
                    <button onClick={() => history.push('/editar-perfil')}>
                      <CreateOutlinedIcon style={CreatedIconStylesMobile} />
                    </button>
                  </h6>
                  <span>{userEmail}</span>
                </UserTexts>
              </MobileUserInfoContainer>
              <ResaleMobileContainer>
                <EconomicGroup stores={stores} mobile={true}>
                  <ResaleMobileContent expand={economicGroupReducer.expand}>
                    <ReleaseIcon src={iconRevendaCinza} alt="Icone revenda" />
                    <ReleaseInfo color="#808080">
                      {storeName}
                      <br />
                      CNPJ: {formatCnpj(storeDocument)}
                    </ReleaseInfo>
                    {expand ? (
                      <ExpandLessIcon style={ColorIconMobile} />
                    ) : (
                      <ExpandMoreIcon style={ColorIconMobile} />
                    )}
                  </ResaleMobileContent>
                </EconomicGroup>
              </ResaleMobileContainer>
            </>
          )
        }
      </MobileWrapper>
    </Container>
  );
}

export default Header;
